<script lang="ts">
</script>

<div class="fizz-container fizz-stack-24">
  <div class="fizz-flex-item fizz-inset-square-16" data-testid="payments_suspended_banner">
    <div class="fizz-alert-error">
      <p><strong>Payments temporarily suspended</strong></p>
      <p class="fizz-text-medium">
        Due to a recent issue in processing an invoice payment, your account has been temporarily
        suspended from paying invoices. We will notify you via email once your account has been
        restored, within one business day.
      </p>
    </div>
  </div>
</div>
